/**
 * assets/lens-selection.js (protegido) sempre abre o modal antigo (com
 * cesta) ou roda addToCartWithFeedback (sem cesta — que por padrão
 * redireciona pra /cart) sem checar a flag do quick-add. Interceptamos o
 * clique em capture-phase pra rodar antes desse listener (fase de bubble)
 * e disparar o mesmo evento do card — em qualquer largura e pros dois
 * estados de cesta — pra PDP se comportar exatamente como o card: abre o
 * overlay/drawer do quick-add, nunca o nativo (bug relatado: produto sem
 * cesta pela PDP — ex. acessório, clip-on — recarregava a página inteira
 * em /cart em vez de abrir o carrinho, e o contador do header perdia o
 * filtro de isAccompanyingItem nesse reload por vir direto do Liquid).
 */

/**
 * Mesma normalização de zrzs-quick-add-overlay.js#handleizeLike — sem
 * ela, "Óculos de Sol"/"Óculos De Sol"/variações de acento quebrariam a
 * comparação exata (frágil, apontado em QA; catálogo atual usa a
 * grafia esperada, mas não custa não depender disso).
 * @param {string | null | undefined} str
 * @returns {string}
 */
function handleizeLike(str) {
  return (str || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * data-gifts vem em pseudo-JSON de aspas simples.
 * @param {string | undefined} raw
 * @returns {any[] | null}
 */
function parseGiftsDataset(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw.replace(/'/g, '"'));
  } catch {
    return null;
  }
}

function handleCapturedClick(event) {
  const target = /** @type {HTMLElement} */ (event.target);
  const button = target.closest?.(
    '.lens-selection__button[data-has-lens-basket]'
  );
  if (!button) return;
  const hasLensBasket = button.dataset.hasLensBasket === 'true';

  const component = button.closest('lens-selection-component');
  if (!component || component.getAttribute('data-quick-add-flow') !== 'true') {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  if (button.disabled) return;

  // snippets/product-title-pdp.liquid (não protegido) já expõe product.type cru.
  const productTypeEl = /** @type {HTMLElement | null} */ (
    document.querySelector('[data-product-type]')
  );
  const isSolar =
    handleizeLike(productTypeEl?.dataset.productType) === 'oculos-de-sol';

  const variantJson = component.querySelector('#variant-picker-json');
  let variant = null;
  try {
    variant = variantJson ? JSON.parse(variantJson.textContent || '') : null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[QuickAddPDP] variant-picker-json inválido:', error);
  }
  if (!variant || !variant.id) return;

  // Mesmo motivo do card (zrzs-quick-add-trigger.js): duplo/triplo clique
  // aqui disparava um /cart/add.js por clique pra solar/grau-puro sem
  // escolha de tamanho — reabilita só via onSettled, quando aquele clique
  // específico terminar de ser processado. Só desabilita depois de
  // garantir que o evento vai mesmo disparar — nunca antes de um `return`
  // que deixaria o botão preso.
  button.disabled = true;

  let image = '';
  if (variant.featured_image && variant.featured_image.src) {
    image = variant.featured_image.src.startsWith('//')
      ? `https:${variant.featured_image.src}`
      : variant.featured_image.src;
  }

  document.dispatchEvent(
    new CustomEvent('zrzs:quick-add:open', {
      detail: {
        pending: true,
        item: {
          image,
          product_title:
            document.querySelector('.product-title')?.textContent?.trim() || '',
          variant_title: variant.title || '',
          // data-frame-price já é promo-aware (mesma precedência do card).
          price: Number(component.dataset.framePrice) || variant.price || 0,
          url: window.location.pathname,
        },
        frameVariantId: variant.id,
        frameVariantTitle: variant.title || '',
        kitVariantId: component.dataset.kitVariantId || null,
        hasLensBasket,
        isSolar,
        // PDP com cesta de lentes sempre força o fluxo de escolha de
        // lentes, mesmo solar com grau (diferente do card — ver
        // zrzs-quick-add-overlay.js#forcesLensFlow). Sem cesta (acessório,
        // clip-on, solar puro): cai direto no mesmo "adiciona e abre o
        // carrinho" que o card já usa — fromPdp não muda nada nesse caso.
        fromPdp: true,
        // Já estamos na página do tamanho escolhido — sem seletor pendente.
        sizes: null,
        hasMeasurements: Boolean(
          document.querySelector('.product-frame-measurements')
        ),
        kitCaseBanner: component.dataset.kitCaseBanner || null,
        kitCaseDescription: component.dataset.kitCaseDescription || null,
        giftsData: parseGiftsDataset(component.dataset.gifts),
        onSettled: () => {
          button.disabled = false;
        },
      },
    })
  );
}

document.addEventListener('click', handleCapturedClick, { capture: true });
